import React from 'react';
import { SkillLayout } from './skill.layout';
import { useParams } from 'react-router';
import { PagePath } from '../../../navigation/navigation.enums';

export function SkillPage(): JSX.Element {
  const { skillSlug } = useParams();

  return <SkillLayout path={PagePath.analyticsSkillSubType} skillSlug={skillSlug!} />;
}

